<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">修改轮播图</div>
      <el-form-item label="排序" prop="sort" :rules="[{required: true,message: ' '}]">
        <el-input type="text" v-model="form.sort" class="max-w460" prop="sort"></el-input>
      </el-form-item>
      <el-form-item label="图片：">
        <el-row>
          <div class="draggable-list">
            <div class="item img-select" v-if="form.img_id==0" @click="chooseImg('logo')"><i class="el-icon-plus"></i></div>
            <div v-if="form.img_id!=0" class="item" @click="chooseImg('logo')">
              <img :src="img_file_path" width="100" height="100" />
            </div>
          </div>
        </el-row>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit()" :loading="loading">提交</el-button>
      </div>

    </el-form>

    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc"></Upload>
  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';

  export default {
    components:{
      Upload
    },
    data() {
      return {
        loading: false,
        /*form表单数据*/
        form: {
          id: '',
          img_id:0,
          sort: null
        },
        img_file_path: '',
        type:null,
        isupload:false,
      };
    },
    created() {
      this.getData();
    },

    methods: {
      /*选择图片*/
      chooseImg(e){
        this.type=e;
        this.isupload=true;
      },

      getData() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.id
        SettingApi.bannerDetail({
          id: params
          }, true)
          .then(data => {
            let detail = data.data.detail;
            // 将数据放在当前组件的数据内
            self.form.id = detail.id;
            self.form.img_id = detail.img_id;
            self.form.sort = detail.sort;
            self.img_file_path = detail.image.file_path;
          })
          .catch(error => {

          });

      },
      //提交表单
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editBanner(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
                 self.$router.push('/setting/banner/index');

              })
              .catch(error => {
                self.loading = false;
              });

          }
        });

      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        if (e != null && e.length > 0) {
          if(this.type == 'logo'){
            this.img_file_path = e[0].file_path;
            this.form.img_id = e[0].file_id;
          }
        }
        this.isupload=false;
      }

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/banner/edit.vue